import { servicePath, type CdnProviderConsole, type ServiceRoute } from '@vnetwork/margarita-shell/service-route';
import { ravenPaths } from './paths';

// Plain data + a lazy loader: do not import the console here (it would join the entry chunk).

/** Domain sub-flows (the org-wide entry to a domain). */
export const servicesRoutes: ServiceRoute[] = [
  { path: servicePath(ravenPaths.newDomain), load: () => import('./index').then((m) => ({ default: m.DomainSetupWizard })) },
  { path: servicePath(ravenPaths.base, ':domainId/*'), load: () => import('./index').then((m) => ({ default: m.DomainDetail })) },
];

/** The console of a CDN service whose provider is Raven. */
export const cdnProviderConsole: CdnProviderConsole = {
  provider: 'raven',
  load: () => import('./index').then((m) => ({ default: m.RavenRoutes })),
};
